import React, { Fragment, useEffect,useState } from "react";
import { Menu, Dropdown } from 'antd';
import styles from "./scss/tasklist.module.scss";
import { StatusTag } from "../../../shared/widgets/statusTag";
import { URButton } from "../../../shared/widgets/button";
import { URInput } from "../../../shared/widgets/input";
import { PriorityBeam } from "../../../shared/widgets/priorityBeam";
import moment from 'moment';
import _ from "lodash";
import { chats, chatwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../models/model";
import { useSelector } from "react-redux";
import NotFound from "../../../styles/images/empty_states/task_empty_state.svg";
import NoContent from "../../../shared/widgets/noContent";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import { URTaskSkeleton } from "../../../shared/skeletonLoading/taskSkeleton";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";
type Taskprops={
  taskLists:any
}
type TaskPageState = {
  searchTask: any;
  filterKey:string;
  taskList:any;
  sortdate:boolean;
  temptaskList:any;
  searchText:any;
}


export default function TaskListsRight({taskLists}:Taskprops) {
  const rightSideLink: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const { chatWindowDetails }: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const {userdetails}: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const [taskList, setTaskList] = useState<TaskPageState>({
    searchTask:[],sortdate:false,
    filterKey:"All",taskList: [],temptaskList:[],searchText:""
  });


  useEffect(() => {
    setTaskList({...taskList,searchTask:taskLists,taskList:taskLists,temptaskList:taskLists
    });
   
  }, [taskLists?.length]);

  const searchTaskinList=(e:any)=>{
    let searchText=e.target.value.toLowerCase();
    let response:any =   _.filter(taskList?.temptaskList, function(data:any) {
      let TaskName = data?.summary || "";
      let Datesearch = moment(new Date(parseInt(data?.dtend)*1000)).format("ddd, MMM Do YYYY") || '';
      return (((TaskName).toLowerCase()).includes(searchText) ||
      (Datesearch.toString()).toLowerCase().includes(searchText));
      
    });
    setTaskList({...taskList,searchTask:response,searchText:searchText});
  };

  const selectfilter = (val:any)=>{
    let status:any = val.key === "In Review"?"In Review":val.key === "Upcoming"?
      ['In Progress','In Review','','On Hold']:val.key;
    let sts:any = val.key === "Upcoming"? status:[status];
    let response : Array<any>;
    if (val.key === "All"){
      taskList['filterKey'] = val.key;
      response = taskList?.taskList?.sort(sortFunction);
    } else if(val.key === "Sort by: Due date") {
      taskList['filterKey'] = val.key;
      response = taskList?.taskList?.sort(sortFunction);
    } else if(val.key === "Upcoming") {
      response = _.filter(taskList?.taskList,(data: any) => {
        return moment(new Date(parseInt(data.dtstart)*1000)) > moment(new Date())  
      });
     
    }  else {
      response =_.filter(taskList?.taskList, (data) => _.includes(sts, data?.taskStatus));
    }
    setTaskList({...taskList,
      searchTask:response,filterKey:val.key,temptaskList:response
    });
   
  };

  const sortFunction=(a:any,b:any)=>{
    let sort:any = "";
    if(taskList.filterKey === 'All'){
      sort = a.dtend - b.dtend;
    } else {
      sort = b.dtend - a.dtend;
    }
    return sort;
  };
 
  const menu = (
    <Menu className="rightdropactions" onClick={selectfilter}>
      <Menu.Item className={taskList.filterKey==='All'?
        "active":''}  key={'All'}><span className="icon_tick"></span><b>All</b></Menu.Item>
      <Menu.Item className={taskList.filterKey==='Sort by: Due date'?
        "active":''} key={'Sort by: Due date'}><span className="icon_tick"  ></span><b>Sort by: Due date</b></Menu.Item>
      <Menu.Item className={taskList.filterKey==='Upcoming'?
        "active":''}  key={'Upcoming'}><span className="icon_tick"  ></span><b>Upcoming</b></Menu.Item>
      <Menu.Item className={taskList.filterKey==='Completed'?
        "active":''}  key={'Completed'}><span className="icon_tick" ></span><b>
          <StatusTag className='statusCompleted' name='Completed'/></b></Menu.Item>
      <Menu.Item className={taskList.filterKey==='In Progress'?
        "active":''}  key={'In Progress'}><span className="icon_tick"  ></span><b>
          <StatusTag className='statusunderinProgress' name='In Progress' /></b></Menu.Item>
      <Menu.Item className={taskList.filterKey==='In Review'?
        "active":''}  key={'In Review'}><span className="icon_tick"  ></span><b>
          <StatusTag className='statusunderReview' name='In Review' /></b></Menu.Item>
      <Menu.Item className={taskList.filterKey==='On Hold'?
        "active":''} key={'On Hold'}><span className="icon_tick"  ></span><b>
          <StatusTag className='statusHold' name='On Hold' /></b></Menu.Item>
    </Menu>
  );

  const showCreateTask =()=>{
    chatSideWindow(true,"task",{});
  };

  const showEditEvent = (eventdata:any)=>{
    chatSideWindow(true,"edittask",eventdata);
  };
  let teamMemberOnly = chatWindowDetails.team_id &&
  chatWindowDetails?.team_members ? _.includes(chatWindowDetails?.team_members, userdetails.sip_login_id) : '';
  
    return (
    <>

      <div className={`fadeIn ${styles.taskmain}`}>
        <div className={styles.rightbartop}>
        {(teamMemberOnly || chatWindowDetails.sip_login_id )&&  <div className={styles.tasknewbtn}>
          <span className={styles.titleText}>Task</span>
            <URButton className={`${'rightnewtask'} ${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} name="New Task" onClick={showCreateTask}/>
          </div>}
          <div className={styles.tasksearchbar}>
            <div className={styles.lefts}>
              <URInput placeHolder="Search" className="rightbarsearch" onChange={searchTaskinList} />
            </div>
            <div className={styles.rights}>
              <Dropdown className="popss2" overlay={menu} trigger={['click']}  placement="bottomRight">
                <p className={taskList.filterKey === 'Completed' ? "statusCompleted" : 
                  taskList.filterKey === 'In Progress' ? "statusunderinProgress" : 
                    taskList.filterKey === 'In Review' ? "statusunderReview" :
                      taskList.filterKey === 'On Hold' ? "statusHold" :""}>{taskList?.filterKey}
                  <span className={`${'icon_down-arrow'} ${'menudroprotate'}`}></span>
                </p>
                
              </Dropdown>
            </div>
          </div>
        </div>
        { (rightSideLink?.isTask===false &&  rightSideLink?.taskListDetails?.length === 0) ?
          [1,2,3,4,5,6,7,8,9,10].map((data:any)=>(
            <div className={styles.skeletonSec} key={data}><URTaskSkeleton key={data}/></div>
          ))
          :(taskList?.searchTask?.length === 0  && !rightSideLink?.taskLoader)?
            <NoContent image={NotFound}
              title={"Worktual Tasks"}
              description={<>Well begun is almost done! <br/>Create and assign tasks.</>} />:
            rightSideLink.isTask && !rightSideLink?.taskLoader&&
             <div className={styles.rightbarbottom}>
               {taskList?.searchTask && taskList?.searchTask?.length > 0 &&
                taskList?.searchTask?.map((taskdata: any, i: any) => (
                  <Fragment key={i}>
                    <div className={chatReducer.isTaskviewontoast &&taskdata.msgId===chatReducer.Taskviewontoast.msgid?
             ` savedhighlight  ${styles.tasklist} ${styles.yellowbg}` :styles.tasklist}onClick={() => showEditEvent(taskdata)} id={taskdata.msgId}>
                      <div className={styles.toplayer}>
                        <h3><HighlightInner content={taskdata?.summary}
                        searchedData={taskList?.searchText}></HighlightInner></h3>
                        <div className={styles.status}>{taskdata.attendee?.length}<span className="icon_profile"></span></div>
                      </div>
                      <div className={styles.topbottomlayer}>
                      <PriorityBeam className={
                    taskdata.priority === "High" ? 'priorityBeam bgRed' : taskdata.priority === "Medium" ?
                      'priorityBeam bgYello' : 'priorityBeam bgGrey'
                  } />
                        {/*<p>Mon, Aug 30, 2021</p>*/}
                        <p className={moment(new Date(parseInt(taskdata.dtend)*1000)) < moment(new Date())  ? styles.taskRed:""}>{moment(new Date(parseInt(taskdata.dtend)*1000)).format("ddd, MMM Do YYYY")}</p>
                        <ul>
                          <li>{taskdata.taskStatus=== "In Review" ?
                            <StatusTag className='statusunderReview' name='In Review' />
                            : taskdata.taskStatus=== "On Hold" ?
                              <StatusTag className='statusHold' name='On Hold' />:
                              taskdata.taskStatus === "Completed"
                                ?
                                <StatusTag className='statusCompleted' name='Completed' />:
                                <StatusTag className='statusunderinProgress' name='In Progress' />
                          }</li>
                        </ul>
                      </div>
                    </div>

                  </Fragment>
                )) }
             </div> }
        
      </div>

    </>
  );
};

